// extracted by mini-css-extract-plugin
export default {"wrapper":"PostIdPage_wrapper__EXZXl"};